import React from "react";
import { Redirect } from "react-router-dom";
import ProSourceForm from "../components/ProSourceForm";
import { Card, Row, Col } from "react-bootstrap";
import { InfoAlertHelper, InfoTooltip, Block } from "../components/Base";
import { RESERVATION_COLOR, DANGER_COLOR, PRIMARY_COLOR } from "../constants";
import core from "../vendors/core-api/";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { fetchData } from "../helpers";
import { isEmpty, startCase } from "lodash";
import PacmanLoading from "../components/widgets/PacmanLoading/PacmanLoading";

// Extracted Components
import ExperienceManager from "./reservations/ExperienceManager";
import DiningServiceManager from "./reservations/DiningServiceManager";
import EditTableModal from "./reservations/EditTableModal";
import TableSettingsOverviewModal from "./reservations/TableSettingsOverviewModal";
import { getCapacityLabel } from "./reservations/utils";

const MySwal = withReactContent(Swal);

export default class ReservationsSettingsDiv extends ProSourceForm {
  constructor(props) {
    super(props);
    const { store, showToggles = false } = props;
    const { isReservationActive = false, isEventActive = false } = store;
    this.api = core("pu").get();
    this.state = {
      isReservationActive: isReservationActive,
      isEventActive: isEventActive,
      store: store ? store : "",
      isLoading: false,
      errors: {},
      touched: {},
      isSubmitting: false,
      redirectTo: "",
      store_tables: [],
      isEditTable: false,
      selected_table: {},
      isAddTable: false,
      max_tables: 500,
      showModal: false,
      showOverviewModal: false,
      experiences: [],
      isExperienceFormVisible: false,
      editingExperience: null,
      diningServices: [],
      isDiningServiceFormVisible: false,
      editingDiningService: null,
      diningServiceGroups: [],
      isDiningServiceGroupFormVisible: false,
      editingDiningServiceGroup: null,
      editingGroupId: null,
      addingToGroupId: null,
    };
    this.showToggles = showToggles;
    this.diningServiceFormRef = React.createRef();
    this.experienceFormRef = React.createRef();
    this.getData = this.getData.bind(this);
  }

  getData = async () => {
    this.setState({ isLoading: true });
    try {
      const [
        tablesResponse,
        experiencesResponse,
        diningServicesResponse,
        diningServiceGroupsResponse,
      ] = await Promise.all([
        this.api.get(
          `/branded-website/stores/${this.props.store._id}/reservable-tables`,
        ),
        this.api.get(`/reservation/${this.props.store._id}/experience`),
        this.api.get(`/reservation/${this.props.store._id}/service`),
        this.api.get(`/reservation/${this.props.store._id}/service-group`),
      ]);

      const newState = { isLoading: false };
      if (tablesResponse.data)
        newState.store_tables = tablesResponse.data.store_tables;
      if (experiencesResponse.data)
        newState.experiences = experiencesResponse.data;
      if (diningServicesResponse.data)
        newState.diningServices = diningServicesResponse.data;
      if (diningServiceGroupsResponse.data)
        newState.diningServiceGroups = diningServiceGroupsResponse.data;

      this.setState(newState);
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  async componentDidMount() {
    const {
      store_tables = [],
      isReservationActive = false,
      diningServices = [],
      experiences = [],
      diningServiceGroups = [],
    } = this.state;
    if (
      isReservationActive &&
      (isEmpty(store_tables) ||
        isEmpty(diningServices) ||
        isEmpty(experiences) ||
        isEmpty(diningServiceGroups))
    ) {
      await this.getData();
    }
  }

  handleReservationStatus = (isChecked) => {
    let values = {};
    const { store } = this.state;
    isChecked = !isChecked; // The original toggles logic was !isChecked, preserving it.
    this.setState({ isReservationActive: isChecked });
    store.isReservationActive = isChecked;
    this.setState({ store });

    values["store_id"] = store._id;
    values["isActive"] = store.isReservationActive;
    this.api
      .put({
        url: "/store/allow-reservation",
        data: values,
      })
      .then(({ data }) => {
        if (data.result === "ok") {
          MySwal.fire({
            icon: "success",
            showConfirmButton: false,
            toast: true,
            timer: 1500,
            title: "Success!",
            text: "You have successfully saved your changes.",
          });
        }
      })
      .catch((err) => {
        if (err.hasOwnProperty("response")) {
          const { data = {} } = err.response,
            { error_message = {} } = data;
          if (!isEmpty(error_message)) {
            MySwal.fire({
              icon: "error",
              title: "Ooops!",
              text: error_message,
              confirmButtonColor: RESERVATION_COLOR,
              confirmButtonText: "OK",
              showCancelButton: false,
            }).then((result) => {
              if (result && result.isConfirmed) {
                const { store, isReservationActive } = this.state;
                store.isReservationActive = !isReservationActive;
                this.setState({
                  store,
                  isReservationActive: !isReservationActive,
                });
              }
            });
          }
        }
      });
  };

  handleEventStatus = (isChecked) => {
    let values = {};
    const { store } = this.state;
    isChecked = !isChecked;
    this.setState({ isEventActive: isChecked });
    store.isEventActive = isChecked;
    this.setState({ store });

    values["store_id"] = store._id;
    values["isActive"] = store.isEventActive;
    this.api
      .put({
        url: "/store/allow-events",
        data: values,
      })
      .then(({ data }) => {
        if (data.result === "ok") {
          MySwal.fire({
            icon: "success",
            showConfirmButton: false,
            toast: true,
            timer: 1500,
            title: "Success!",
            text: "You have successfully saved your changes.",
          });
        }
      })
      .catch((err) => {
        if (err.hasOwnProperty("response")) {
          const { data = {} } = err.response,
            { error_message = {} } = data;
          if (!isEmpty(error_message)) {
            MySwal.fire({
              icon: "error",
              title: "Ooops!",
              text: error_message,
              confirmButtonColor: RESERVATION_COLOR,
              confirmButtonText: "OK",
              showCancelButton: false,
            }).then((result) => {
              if (result && result.isConfirmed) {
                const { store, isEventActive } = this.state;
                store.isEventActive = !isEventActive;
                this.setState({ store, isEventActive: !isEventActive });
              }
            });
          }
        }
      });
  };

  handleTableReservationStatus = async (checked, item) => {
    if (checked && isEmpty(item.dining_services)) {
      MySwal.fire({
        icon: "warning",
        title: "Dining Service Required",
        text: "This table cannot be marked as reservable because it has no dining services assigned. Please assign at least one dining service in Table Settings first.",
        confirmButtonColor: PRIMARY_COLOR,
        confirmButtonText: "OK",
      });
      return;
    }
    const store_id = this.state.store._id;
    try {
      const { data } = await fetchData(
        "put",
        `store/${store_id}/tables/${item._id}/reservable`,
        {
          reservable: checked,
        },
      );
      if (data.success) {
        this.getData();
        MySwal.fire({
          icon: "success",
          showConfirmButton: false,
          toast: true,
          timer: 1500,
          title: "Success!",
          text: "You have successfully saved your changes.",
        });
      }
    } catch (err) {
      if (err.hasOwnProperty("response")) {
        const { data = {} } = err.response,
          { error_message = {} } = data;
        if (!isEmpty(error_message)) {
          MySwal.fire({
            icon: "error",
            title: "Ooops!",
            text: error_message,
            confirmButtonColor: PRIMARY_COLOR,
            confirmButtonText: "OK",
            showCancelButton: false,
          });
        }
      }
    }
  };

  onDeleteTable = async (table_id = "") => {
    if (!isEmpty(table_id)) {
      const store_id = this.state.store._id;
      try {
        const { data } = await fetchData(
          "put",
          `store/${store_id}/remove-table-reservation/${table_id}`,
        );
        if (data.success) {
          this.setState({
            showModal: false,
            isEditTable: false,
            isAddTable: false,
            selected_table: null,
          });
          this.getData();
          MySwal.fire({
            icon: "success",
            showConfirmButton: false,
            toast: true,
            timer: 1500,
            title: "Success!",
            text: "You have successfully saved your changes.",
          });
        }
      } catch (err) {
        if (err.hasOwnProperty("response")) {
          const { data = {} } = err.response,
            { error_message = {} } = data;
          if (!isEmpty(error_message)) {
            MySwal.fire({
              icon: "error",
              title: "Ooops!",
              text: error_message,
              confirmButtonColor: PRIMARY_COLOR,
              confirmButtonText: "OK",
              showCancelButton: false,
            });
          }
        }
      }
    }
  };

  // --- Experience Handlers ---
  handleExperienceAddNewClick = () => {
    this.setState(
      { editingExperience: null, isExperienceFormVisible: true },
      () => {
        const element = this.experienceFormRef.current;
        if (element) {
          const y =
            element.getBoundingClientRect().top + window.pageYOffset + 50;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      },
    );
  };

  handleExperienceEdit = (experience) => {
    this.setState(
      {
        editingExperience: experience,
        isExperienceFormVisible: true,
      },
      () => {
        const element = this.experienceFormRef.current;
        if (element) {
          const y =
            element.getBoundingClientRect().top + window.pageYOffset + 50;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      },
    );
  };

  handleExperienceDelete = async (experienceId) => {
    const result = await MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: RESERVATION_COLOR,
      cancelButtonColor: DANGER_COLOR,
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      try {
        await this.api.delete({
          url: `/reservation/experience/${experienceId}`,
        });
        MySwal.fire({
          icon: "success",
          showConfirmButton: false,
          toast: true,
          title: "Deleted!",
          text: `The experience has been deleted.`,
          timer: 1500,
        });
        this.handleExperienceCancel();
        this.getData();
      } catch (err) {
        MySwal.fire("Error!", "Could not delete the experience.", "error");
      }
    }
  };

  handleExperienceSave = async (experienceData) => {
    const { store, editingExperience } = this.state;
    this.setState({ isSubmitting: true });
    try {
      if (editingExperience) {
        // Update
        await this.api.put({
          url: `/reservation/experience/${editingExperience._id}`,
          data: experienceData,
        });
      } else {
        // Create
        await this.api.post({
          url: `/reservation/${store._id}/experience`,
          data: experienceData,
        });
      }

      MySwal.fire({
        icon: "success",
        showConfirmButton: false,
        toast: true,
        title: "Success!",
        text: `Experience has been ${
          editingExperience ? "updated" : "created"
        }.`,
        timer: 1500,
      });

      this.setState({
        isExperienceFormVisible: false,
        editingExperience: null,
        isSubmitting: false,
      });
      this.getData();
    } catch (err) {
      const error_message =
        err?.response?.data?.error_message ||
        "An error occurred. Please try again.";
      MySwal.fire({
        icon: "error",
        title: "Oops...",
        text: error_message,
        confirmButtonColor: DANGER_COLOR,
      });
      this.setState({ isSubmitting: false });
    }
  };

  handleExperienceCancel = () => {
    this.setState({
      isExperienceFormVisible: false,
      editingExperience: null,
    });
  };

  // --- Dining Service Handlers ---
  handleDiningServiceGroupAddNewClick = () => {
    this.setState({
      editingDiningService: null,
      isDiningServiceGroupFormVisible: true,
    });
  };

  handleDiningServiceAddNewClick = () => {
    this.setState({
      editingDiningService: null,
      isDiningServiceFormVisible: true,
    });
  };

  handleDiningServiceEdit = (diningService) => {
    this.setState({
      editingDiningService: diningService,
      isDiningServiceFormVisible: false,
    });
  };

  handleDiningServiceDelete = async (serviceId) => {
    const result = await MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: RESERVATION_COLOR,
      cancelButtonColor: DANGER_COLOR,
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      try {
        await this.api.delete({
          url: `/reservation/service/${serviceId}`,
        });
        MySwal.fire({
          icon: "success",
          showConfirmButton: false,
          toast: true,
          title: "Deleted!",
          text: `The dining service has been deleted.`,
          timer: 1500,
        });
        this.handleDiningServiceCancel();
        this.getData();
      } catch (err) {
        MySwal.fire("Error!", "Could not delete the dining service.", "error");
      }
    }
  };

  handleDiningServiceSave = async (serviceData) => {
    const { store, editingDiningService } = this.state;
    this.setState({ isSubmitting: true });

    try {
      if (editingDiningService) {
        // Update
        await this.api.put({
          url: `/reservation/service/${editingDiningService._id}`,
          data: serviceData,
        });
      } else {
        // Create
        await this.api.post({
          url: `/reservation/${store._id}/service`,
          data: serviceData,
        });
      }

      MySwal.fire({
        icon: "success",
        showConfirmButton: false,
        toast: true,
        title: "Success!",
        text: `Dining Service has been ${
          editingDiningService ? "updated" : "created"
        }.`,
        timer: 1500,
      });

      this.setState({
        isDiningServiceFormVisible: false,
        editingDiningService: null,
        isSubmitting: false,
      });
      this.getData();
    } catch (err) {
      const error_message =
        err?.response?.data?.error_message ||
        "An error occurred. Please try again.";
      MySwal.fire({
        icon: "error",
        title: "Oops...",
        text: error_message,
        confirmButtonColor: DANGER_COLOR,
      });
      this.setState({ isSubmitting: false });
    }
  };

  handleDiningServiceCancel = () => {
    this.setState({
      isDiningServiceFormVisible: false,
      editingDiningService: null,
      addingToGroupId: null,
    });
  };

  // --- Group Handlers ---
  handleDiningServiceGroupSave = async (groupData) => {
    const { store } = this.state;
    const isUpdate = !!groupData._id;

    this.setState({ isSubmitting: true });
    try {
      let savedGroup;
      if (isUpdate) {
        savedGroup = await this.api.put({
          url: `/reservation/service-group/${groupData._id}`,
          data: groupData,
        });
      } else {
        const { data } = await this.api.post({
          url: `/reservation/${store._id}/service-group`,
          data: { name: groupData.name, active: groupData.active },
        });
        savedGroup = data;

        if (groupData.service_name) {
          const newServiceData = {
            name: groupData.service_name,
            start_time: groupData.start_time,
            end_time: groupData.end_time,
            interval: groupData.interval,
            experiences: groupData.experiences,
            dining_service_group: savedGroup._id,
          };
          await this.handleDiningServiceSave(newServiceData);
        }
      }
      MySwal.fire({
        icon: "success",
        toast: true,
        title: "Success!",
        text: `Service Group has been ${isUpdate ? "updated" : "created"}.`,
        timer: 1500,
        showConfirmButton: false,
      });
      this.setState({
        isDiningServiceGroupFormVisible: false,
        editingDiningServiceGroup: null,
        isSubmitting: false,
      });
      this.getData();
    } catch (err) {
      MySwal.fire("Error!", "Could not save the service group.", "error");
      this.setState({ isSubmitting: false });
    }
  };

  handleDiningServiceGroupCancel = () => {
    this.setState({
      isDiningServiceGroupFormVisible: false,
      editingDiningServiceGroup: null,
    });
  };

  handleDiningServiceGroupDelete = async (groupId) => {
    const { diningServices } = this.state;
    const servicesInGroup = diningServices.filter(
      (service) => service.dining_service_group === groupId,
    );

    if (servicesInGroup.length > 0) {
      return MySwal.fire({
        icon: "error",
        title: "Cannot Delete Service",
        text: "This service has dining slot. Please remove them before deleting.",
        confirmButtonColor: DANGER_COLOR,
      });
    }

    const result = await MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: RESERVATION_COLOR,
      cancelButtonColor: DANGER_COLOR,
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await this.api.delete({ url: `/reservation/service-group/${groupId}` });
        this.getData();
      } catch (err) {
        MySwal.fire("Error!", "Could not delete the service group.", "error");
      }
    }
  };

  handleGroupNameChange = (e, groupId) => {
    const { diningServiceGroups } = this.state;
    const newDiningServiceGroups = diningServiceGroups.map((group) => {
      if (group._id === groupId) {
        return { ...group, name: e.target.value };
      }
      return group;
    });
    this.setState({ diningServiceGroups: newDiningServiceGroups });
  };

  handleGroupNameBlur = (group) => {
    this.handleDiningServiceGroupSave(group);
  };

  render() {
    const {
      isReservationActive,
      isEventActive = false,
      store_tables = [],
      isLoading,
      isEditTable = false,
      selected_table = {},
      store = {},
      showModal = false,
      max_tables,
      experiences,
      isExperienceFormVisible,
      editingExperience,
      diningServices,
      isDiningServiceFormVisible,
      editingDiningService,
      diningServiceGroups,
      isDiningServiceGroupFormVisible,
      editingDiningServiceGroup,
      editingGroupId,
      addingToGroupId,
    } = this.state;

    return (
      <>
        {this.state.redirectTo !== "" ? (
          <Redirect to={this.state.redirectTo} push={true} />
        ) : (
          <></>
        )}

        <Card className="card-custom gutter-b">
          <Card.Header>
            <Card.Title>Experiences Settings</Card.Title>
          </Card.Header>

          <Card.Body>
            {this.showToggles && (
              <>
                <InfoAlertHelper
                  text={
                    "You can manage your reservations or events service availability in your Experiences Settings"
                  }
                />
                <Card className="d-flex justify-content-between w-100 mb-4">
                  <Card.Body>
                    <div className="row d-flex align-items-center justify-content-start">
                      <div
                        className="row d-flex align-items-center"
                        style={{ flexBasis: "48%" }}
                      >
                        <span className="switch switch-outline switch-icon switch-primary m-0 ml-4 pl-4 pt-2">
                          <label className="mb-0">
                            <input
                              type="checkbox"
                              name="isEventActive"
                              checked={isEventActive}
                              onChange={() =>
                                this.handleEventStatus(isEventActive)
                              }
                            />
                            <span></span>
                          </label>
                        </span>
                        <label className="text-dark font-weight-bolder text-uppercase mb-0 pl-3 pr-0">
                          Allow Events
                        </label>
                        {InfoTooltip(
                          `Turning this ${"off"} will remove the events experience for your customers.`,
                        )}
                      </div>
                      <div
                        className="row d-flex align-items-center"
                        style={{ flexBasis: "55%" }}
                      >
                        <span className="switch switch-outline switch-icon switch-primary m-0 ml-4 pl-4 pt-2">
                          <label className="mb-0">
                            <input
                              type="checkbox"
                              name="isReservationActive"
                              checked={isReservationActive}
                              onChange={() =>
                                this.handleReservationStatus(
                                  isReservationActive,
                                )
                              }
                            />
                            <span></span>
                          </label>
                        </span>
                        <label className="text-dark font-weight-bolder text-uppercase mb-0 pl-3 pr-0">
                          Allow Reservations
                        </label>
                        {InfoTooltip(
                          `Turning this ${
                            isReservationActive ? "off" : "on"
                          } will ${
                            isReservationActive ? "remove" : "enable"
                          } the reservations experience for your customers.`,
                        )}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </>
            )}
            <div className="d-flex flex-column">
              <div className="d-flex justify-content-start mb-4">
                <button
                  type="button"
                  className="btn btn-sm btn-info font-weight-boldest mr-2 mb-2 mb-sm-0"
                  onClick={() =>
                    this.setState({
                      showOverviewModal: true,
                    })
                  }
                  style={{
                    backgroundColor: RESERVATION_COLOR,
                    borderColor: RESERVATION_COLOR,
                  }}
                >
                  <i className="far fa-calendar-alt mr-2" /> Experience and
                  Tables Availability
                </button>
              </div>
              <Row>
                <Col xl={4} lg={5} className="mb-6 mb-lg-0">
                  <div ref={this.experienceFormRef}>
                    <Block
                      content={
                        <Card
                          className="d-flex justify-content-between h-100"
                          style={{
                            borderTop: `5px solid ${RESERVATION_COLOR}`,
                            borderRadius: "12px",
                          }}
                        >
                          <Card.Header className="font-weight-boldest border-0 py-6">
                            <div className="d-flex justify-content-between align-items-center">
                              <h3
                                className="m-0 text-dark-75 font-weight-boldest"
                                style={{ fontSize: "1.2rem" }}
                              >
                                Experiences
                              </h3>
                            </div>
                          </Card.Header>
                          <Card.Body className="pt-2">
                            <ExperienceManager
                              experiences={experiences}
                              isFormVisible={isExperienceFormVisible}
                              editingExperience={editingExperience}
                              onAddNewClick={this.handleExperienceAddNewClick}
                              onEdit={this.handleExperienceEdit}
                              onDelete={this.handleExperienceDelete}
                              onSave={this.handleExperienceSave}
                              onCancel={this.handleExperienceCancel}
                            />
                          </Card.Body>
                        </Card>
                      }
                    />
                  </div>
                </Col>
                <Col xl={8} lg={7} className="pl-lg-5">
                  <div ref={this.diningServiceFormRef}>
                    <Block
                      content={
                        <Card
                          className="d-flex justify-content-between w-100"
                          style={{
                            borderTop: `5px solid ${RESERVATION_COLOR}`,
                            borderRadius: "12px",
                          }}
                        >
                          <Card.Header className="font-weight-boldest border-0 py-6">
                            <div className="d-flex justify-content-between align-items-center">
                              <h3
                                className="m-0 text-dark-75 font-weight-boldest"
                                style={{ fontSize: "1.2rem" }}
                              >
                                Dining Services
                              </h3>
                              <div className="d-flex">
                                <button
                                  disabled={this.state.isLoading}
                                  type="button"
                                  className="btn btn-sm btn-light-info font-weight-boldest"
                                  onClick={() => {
                                    this.handleDiningServiceGroupAddNewClick();
                                  }}
                                >
                                  <i className="fas fa-plus mr-1" /> Add Dining
                                  Service
                                </button>
                              </div>
                            </div>
                          </Card.Header>
                          <Card.Body className="pt-2">
                            <DiningServiceManager
                              diningServices={diningServices}
                              isFormVisible={isDiningServiceFormVisible}
                              isDiningServiceGroupFormVisible={
                                isDiningServiceGroupFormVisible
                              }
                              editingDiningServiceGroup={
                                editingDiningServiceGroup
                              }
                              editingDiningService={editingDiningService}
                              onAddNewClick={
                                this.handleDiningServiceAddNewClick
                              }
                              onEdit={this.handleDiningServiceEdit}
                              onDelete={this.handleDiningServiceDelete}
                              onSave={this.handleDiningServiceSave}
                              onCancel={this.handleDiningServiceCancel}
                              experiences={experiences}
                              diningServiceGroups={diningServiceGroups}
                              onGroupEdit={this.handleDiningServiceGroupEdit}
                              onGroupSave={this.handleDiningServiceGroupSave}
                              onGroupCancel={
                                this.handleDiningServiceGroupCancel
                              }
                              editingGroupId={editingGroupId}
                              addingToGroupId={addingToGroupId}
                              setEditingGroupId={(id) =>
                                this.setState({ editingGroupId: id })
                              }
                              setAddingToGroupId={(id) =>
                                this.setState({ addingToGroupId: id })
                              }
                              onGroupDelete={
                                this.handleDiningServiceGroupDelete
                              }
                              onGroupNameChange={this.handleGroupNameChange}
                              onGroupNameBlur={this.handleGroupNameBlur}
                            />
                          </Card.Body>
                        </Card>
                      }
                    />
                  </div>
                </Col>
              </Row>
              <div style={{ width: "100%" }} className="mt-4">
                <Block
                  content={
                    <>
                      {isReservationActive && (
                        <>
                          <Card
                            className="d-flex justify-content-between w-100"
                            style={{
                              //
                              borderTop: `5px solid ${RESERVATION_COLOR}`,
                            }}
                          >
                            <Card.Header className="font-weight-boldest border-0 py-6">
                              <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                                <h3
                                  className="m-0 text-dark-75 font-weight-boldest mb-3 mb-sm-0"
                                  style={{ fontSize: "1.2rem" }}
                                >
                                  Tables
                                </h3>
                                <div className="d-flex flex-wrap align-items-center">
                                  <button
                                    disabled={this.state.isLoading}
                                    type="button"
                                    className="btn btn-sm btn-light-info font-weight-boldest"
                                    onClick={() => {
                                      if (store_tables.length >= max_tables) {
                                        MySwal.fire({
                                          icon: "error",
                                          title: "Ooops!",
                                          text: `Tables are currently capped at ${max_tables}.`,
                                          confirmButtonColor: DANGER_COLOR,
                                          confirmButtonText: "Ok",
                                        });
                                      } else {
                                        this.setState({
                                          isAddTable: true,
                                          showModal: true,
                                        });
                                      }
                                    }}
                                  >
                                    <i className="fas fa-plus mr-1" /> Add Table
                                  </button>
                                </div>
                              </div>
                            </Card.Header>
                            <Card.Body>
                              {isLoading && (
                                <div className="h-100 w-100 d-flex flex-column align-items-center">
                                  <PacmanLoading />
                                </div>
                              )}
                              <div className="row">
                                {!isLoading &&
                                  store_tables.length > 0 &&
                                  store_tables.map((table, idx) => (
                                    <div
                                      key={`store-table-${idx}`}
                                      className="col-xl-4 col-lg-6 col-md-6 mb-7"
                                    >
                                      <div
                                        className="card card-custom h-100 shadow-sm border pulse pulse-info"
                                        style={{ transition: "all 0.3s ease" }}
                                      >
                                        {/* TABLE IMAGE / HEADER */}
                                        <div
                                          className="card-header border-0 min-h-150px"
                                          style={{
                                            backgroundImage: `url(${
                                              table.item?.image_url ||
                                              "placeholder-wine-table.jpg"
                                            })`,
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                            position: "relative",
                                            borderTopLeftRadius: "0.42rem",
                                            borderTopRightRadius: "0.42rem",
                                          }}
                                        >
                                          <div
                                            className="card-toolbar"
                                            style={{
                                              position: "absolute",
                                              top: "10px",
                                              right: "10px",
                                            }}
                                          >
                                            <span
                                              className={`badge badge-pill font-weight-boldest mr-1 ${
                                                table.isReservable
                                                  ? "badge-success"
                                                  : "badge-danger"
                                              }`}
                                              style={{
                                                fontSize: "0.7rem",
                                                letterSpacing: "0.5px",
                                              }}
                                            >
                                              {table.isReservable
                                                ? "RESERVABLE"
                                                : "INACTIVE"}
                                            </span>
                                            {table.isExclusive && (
                                              <span
                                                className="badge badge-pill badge-primary font-weight-boldest"
                                                style={{
                                                  fontSize: "0.7rem",
                                                  letterSpacing: "0.5px",
                                                  backgroundColor:
                                                    RESERVATION_COLOR,
                                                }}
                                              >
                                                EXCLUSIVE
                                              </span>
                                            )}
                                          </div>
                                        </div>

                                        {/* CARD BODY */}
                                        <div className="card-body p-6 d-flex flex-column">
                                          {/* Title & Edit Link */}
                                          <div className="mb-2">
                                            <h3
                                              className="text-dark font-weight-boldest mb-1"
                                              style={{ fontSize: "1.25rem" }}
                                            >
                                              {startCase(table.name) ||
                                                "Table Reservation"}
                                            </h3>
                                          </div>

                                          {/* Description */}
                                          <div className="mb-4 flex-grow-1">
                                            <p
                                              className="text-muted font-size-sm mb-0"
                                              style={{ lineHeight: "1.4" }}
                                            >
                                              {table.item?.description?.length >
                                              90
                                                ? table.item.description.substring(
                                                    0,
                                                    90,
                                                  ) + "..."
                                                : table.item?.description ||
                                                  "No description available."}
                                            </p>
                                          </div>

                                          {/* Capacity & Toggle Row */}
                                          <div className="d-flex align-items-center justify-content-between mb-5">
                                            <div className="d-flex align-items-center">
                                              <span className="symbol symbol-35 symbol-light-info mr-3">
                                                <span className="symbol-label">
                                                  <i className="fas fa-users text-info font-size-h5"></i>
                                                </span>
                                              </span>
                                              <div className="d-flex flex-column">
                                                <span className="text-muted font-weight-bold font-size-xs text-uppercase">
                                                  Capacity
                                                </span>
                                                <span className="text-dark-75 font-weight-bolder font-size-sm">
                                                  {getCapacityLabel(table)}
                                                </span>
                                              </div>
                                            </div>

                                            <div className="d-flex align-items-center">
                                              <span className="switch switch-outline switch-icon switch-info switch-sm">
                                                <label className="mb-0">
                                                  <input
                                                    type="checkbox"
                                                    checked={table.isReservable}
                                                    onChange={(e) =>
                                                      this.handleTableReservationStatus(
                                                        e.target.checked,
                                                        table,
                                                      )
                                                    }
                                                  />
                                                  <span></span>
                                                </label>
                                              </span>
                                            </div>
                                          </div>

                                          {/* Services Tags */}
                                          <div
                                            className="d-flex flex-wrap mb-5"
                                            style={{ minHeight: "26px" }}
                                          >
                                            {table.dining_services
                                              ?.slice(0, 4)
                                              .map((service) => (
                                                <span
                                                  key={service._id}
                                                  className="badge badge-light-info font-weight-bold mr-1 mb-1"
                                                  style={{ fontSize: "0.7rem" }}
                                                >
                                                  {service.name}
                                                </span>
                                              ))}
                                            {table.dining_services?.length >
                                              4 && (
                                              <span
                                                className="badge badge-light font-weight-bold mb-1"
                                                style={{ fontSize: "0.7rem" }}
                                              >
                                                +
                                                {table.dining_services.length -
                                                  4}
                                              </span>
                                            )}
                                            {isEmpty(table.dining_services) && (
                                              <span
                                                className="badge badge-light-danger text-danger font-weight-bold mb-1"
                                                style={{ fontSize: "0.75rem" }}
                                              >
                                                <i className="fas fa-exclamation-triangle text-danger mr-1"></i>
                                                No Dining Services Assigned
                                              </span>
                                            )}
                                          </div>

                                          {/* Footer Action */}
                                          <div className="border-top pt-5">
                                            <button
                                              className="btn btn-light-info font-weight-boldest btn-block text-uppercase shadow-sm"
                                              style={{
                                                letterSpacing: "1px",
                                                fontSize: "0.8rem",
                                              }}
                                              onClick={() =>
                                                this.setState({
                                                  showModal: true,
                                                  isEditTable: true,
                                                  selected_table: table,
                                                })
                                              }
                                            >
                                              Table Settings
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </Card.Body>
                          </Card>
                        </>
                      )}
                    </>
                  }
                ></Block>
              </div>
            </div>
          </Card.Body>
          {showModal && (
            <EditTableModal
              show={showModal}
              selected_table={selected_table}
              hideEditModal={() =>
                this.setState({
                  showModal: false,
                  isEditTable: false,
                  isAddTable: false,
                  selected_table: null,
                })
              }
              diningServices={diningServices}
              onDeleteTable={this.onDeleteTable}
              store={store}
              isEdit={isEditTable}
              getData={this.getData}
            />
          )}
          {this.state.showOverviewModal && (
            <TableSettingsOverviewModal
              show={this.state.showOverviewModal}
              onHide={() => this.setState({ showOverviewModal: false })}
              tables={store_tables}
              experiences={experiences}
              store={store}
              onSuccess={this.getData}
            />
          )}
        </Card>
      </>
    );
  }
}
